import { TweenLite, Power2 } from "gsap";
import "gsap/src/uncompressed/plugins/ScrollToPlugin";

class ReadMore {
  constructor(elem, windowSizes) {
    this.windowSizes = windowSizes;
    this.elem = elem;
    this.txtContainer = elem.querySelector(".read-more");
    this.txt = elem.querySelector("p");
    this.trigger = elem.querySelector(".read-more__trigger");
    this.opened = false;
    this.calcHeights();
    this.initEvents();
    this.setSizes();
  }

  /** Events onChange sur les selects */
  initEvents() {
    this.trigger.addEventListener("click", () => {
      this.toggleState();
    });
  }

  toggleState() {
    if (this.opened) {
      this.close();
    } else {
      this.open();
    }
  }

  calcHeights() {
    this.initialHeight = window.getComputedStyle(this.txtContainer).maxHeight;
    this.maxHeight = window.getComputedStyle(this.txt).height;
  }

  close() {
    this.opened = false;
    TweenLite.to(this.txtContainer, .25, {
      maxHeight: this.initialHeight,
    })
    this.trigger.innerHTML = "Lire la suite";
  }

  open() {
    this.opened = true;
    TweenLite.to(this.txtContainer, .25, {
      maxHeight: this.maxHeight,
    })
    this.trigger.innerHTML = "Réduire";
  }

  setSizes() {
    this.txtContainer.removeAttribute('style');
    this.calcHeights();
    this.close();
  }

  /** Resize Event */
  resize(windowSizes) {
    if (this.elem) {
      this.windowSizes = windowSizes;      
      this.setSizes();
    }
  }
}

export default ReadMore;



// WEBPACK FOOTER //
// ./src/js/components/ReadMore.js